import { IActivityHistoryItem } from "../model";
import { isString, isValidDateString } from "./utils";

export const isValidBasicActivityHistoryItem = (obj: IActivityHistoryItem) => {
  // Comprobación del objeto principal
  return (
    obj &&
    isString(obj.id) && // Verifica que "id" esté informado
    isValidDateString(obj.date) // Verifica que "date" sea un string de fecha válido
  );
};

export const ensureAreValidBasicActivityHistoryItems = (items: IActivityHistoryItem[]) => {
  const areValid = items.every(isValidBasicActivityHistoryItem);
  if (!areValid) {
    console.error("Invalid activity history items", items);
    throw new Error("Invalid activity history items");
  }
  return items;
};

const notifyInvalidItem = (item: IActivityHistoryItem) => {
  console.error("Invalid history item", item);
};

export const validateAndFilterBasicItems = (items: IActivityHistoryItem[]) => {
  const validItems = [] as IActivityHistoryItem[];
  for (const item of items) {
    if (isValidBasicActivityHistoryItem(item)) validItems.push(item);
    else notifyInvalidItem(item);
  }
  return validItems;
};
